exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sub-title[data-v-539ca12d]{color:#4a5568;font-weight:500;line-height:26px;font-size:1.2rem;display:inline-block}", ""]);

// exports
